// ** react imports
import React from 'react';

// ** styles imports
import './style.css';

const PrivacyPolicy = () => {
  // SVG Logo Component
  const LogoSVG = () => <span className="logo"></span>;

  return (
    <div className="max-w-4xl mx-auto px-4 py-8">
      <div className="flex justify-center mb-12">
        <LogoSVG />
      </div>

      <div data-custom-class="body">
        <div>
          <strong>
            <span style={{ fontSize: '26px' }}>
              <span data-custom-class="title">
                <h1 className="text-3xl font-bold">PRIVACY POLICY</h1>
              </span>
            </span>
          </strong>
        </div>

        <div>
          <span style={{ color: 'rgb(127, 127, 127)' }}>
            <strong>
              <span style={{ fontSize: '15px' }}>
                <span data-custom-class="subtitle">
                  Last updated October 17, 2025
                </span>
              </span>
            </strong>
          </span>
        </div>

        <div>
          <br />
        </div>
        <div>
          <br />
        </div>
        <div>
          <br />
        </div>

        <div style={{ lineHeight: '1.5' }}>
          <span style={{ color: 'rgb(127, 127, 127)' }}>
            <span style={{ color: 'rgb(89, 89, 89)', fontSize: '15px' }}>
              <span data-custom-class="body_text">
                This Privacy Notice for <strong>MultiTax</strong> (doing
                business as <strong>Multitax Financial Solutions</strong>) ({' '}
                &quot;<strong>we</strong>&quot;, &quot;<strong>us</strong>
                &quot;, or &quot;
                <strong>our</strong>&quot;), describes how and why we might
                access, collect, store, use, and/or share (
                <strong>process</strong>) your personal information when you use
                our services (<strong>Services</strong>
                ), including when you:
              </span>
            </span>
          </span>
        </div>

        <ul>
          <li data-custom-class="body_text" style={{ lineHeight: '1.5' }}>
            <span style={{ fontSize: '15px', color: 'rgb(89, 89, 89)' }}>
              <span data-custom-class="body_text">
                Download and use our mobile application{' '}
                <strong>MultiTax</strong> or any other application of ours that
                links to this Privacy Notice
              </span>
            </span>
          </li>
        </ul>

        <div style={{ lineHeight: '1.5' }}>
          <span style={{ fontSize: '15px', color: 'rgb(89, 89, 89)' }}>
            <span data-custom-class="body_text">
              Engage with us in other related ways, including any sales,
              marketing, or events
            </span>
          </span>
        </div>

        <div style={{ lineHeight: '1.5' }}>
          <span style={{ fontSize: '15px', color: 'rgb(89, 89, 89)' }}>
            <span data-custom-class="body_text">
              <strong>Questions or concerns? </strong>
              Reading this Privacy Notice will help you understand your privacy
              rights and choices. We are responsible for making decisions about
              how your personal information is processed. If you do not agree
              with our policies and practices, please do not use our Services.
              If you still have any questions or concerns, please contact us at{' '}
              <a
                target="_blank"
                data-custom-class="link"
                href="mailto:info@multitaxx.com"
                className="text-blue-600 hover:underline"
                rel="noreferrer"
              >
                info@multitaxx.com
              </a>
              .
            </span>
          </span>
        </div>

        <div style={{ lineHeight: '1.5' }}>
          <br />
        </div>
        <div style={{ lineHeight: '1.5' }}>
          <br />
        </div>

        <div style={{ lineHeight: '1.5' }}>
          <span style={{ fontSize: '15px' }}>
            <span data-custom-class="heading_1">
              <h2 className="text-2xl font-bold">SUMMARY OF KEY POINTS</h2>
            </span>
          </span>
        </div>

        <div style={{ lineHeight: '1.5' }}>
          <span style={{ fontSize: '15px' }}>
            <span data-custom-class="body_text">
              <strong>
                <em>
                  This summary provides key points from our Privacy Notice, but
                  you can find out more details about any of these topics by
                  clicking the link following each key point or by using
                  our{' '}
                </em>
              </strong>
              <a
                data-custom-class="link"
                href="#toc"
                className="text-blue-600 hover:underline"
              >
                <span style={{ color: 'rgb(0, 58, 250)', fontSize: '15px' }}>
                  <span data-custom-class="body_text">
                    <strong>
                      <em>table of contents</em>
                    </strong>
                  </span>
                </span>
              </a>
              <span style={{ fontSize: '15px' }}>
                <span data-custom-class="body_text">
                  <strong>
                    <em> below to find the section you are looking for.</em>
                  </strong>
                </span>
              </span>
            </span>
          </span>
        </div>

        <div style={{ lineHeight: '1.5' }}>
          <br />
        </div>

        <div style={{ lineHeight: '1.5' }}>
          <span style={{ fontSize: '15px' }}>
            <span data-custom-class="body_text">
              <strong>What personal information do we process?</strong> When you
              visit, use, or navigate our Services, we may process personal
              information depending on how you interact with us and the
              Services, the choices you make, and the products and features you
              use. Learn more about{' '}
              <a
                data-custom-class="link"
                href="#personalinfo"
                className="text-blue-600 hover:underline"
              >
                <span style={{ color: 'rgb(0, 58, 250)', fontSize: '15px' }}>
                  <span data-custom-class="body_text">
                    personal information you disclose to us
                  </span>
                </span>
              </a>
              .
            </span>
          </span>
        </div>

        <div style={{ lineHeight: '1.5' }}>
          <br />
        </div>

        <div style={{ lineHeight: '1.5' }}>
          <span style={{ fontSize: '15px' }}>
            <span data-custom-class="body_text">
              <strong>
                Do we process any sensitive personal information?{' '}
              </strong>
              Some of the information may be considered &quot;special&quot; or
              &quot;sensitive&quot; in certain jurisdictions, for example your
              racial or ethnic origins, sexual orientation, and religious
              beliefs. We may process sensitive personal information when
              necessary with your consent or as otherwise permitted by
              applicable law. Learn more about{' '}
              <a
                data-custom-class="link"
                href="#sensitiveinfo"
                className="text-blue-600 hover:underline"
              >
                <span style={{ color: 'rgb(0, 58, 250)', fontSize: '15px' }}>
                  <span data-custom-class="body_text">
                    sensitive information we process
                  </span>
                </span>
              </a>
              .
            </span>
          </span>
        </div>

        <div style={{ lineHeight: '1.5' }}>
          <br />
        </div>

        <div style={{ lineHeight: '1.5' }}>
          <span style={{ fontSize: '15px' }}>
            <span data-custom-class="body_text">
              <strong>Do we collect any information from third parties?</strong>{' '}
              We do not collect any information from third parties.
            </span>
          </span>
        </div>

        <div style={{ lineHeight: '1.5' }}>
          <br />
        </div>

        <div style={{ lineHeight: '1.5' }}>
          <span style={{ fontSize: '15px' }}>
            <span data-custom-class="body_text">
              <strong>How do we process your information?</strong> We process
              your information to provide, improve, and administer our Services,
              communicate with you, for security and fraud prevention, and to
              comply with law. We may also process your information for other
              purposes with your consent. We process your information only when
              we have a valid legal reason to do so. Learn more about{' '}
              <a
                data-custom-class="link"
                href="#infouse"
                className="text-blue-600 hover:underline"
              >
                <span style={{ color: 'rgb(0, 58, 250)', fontSize: '15px' }}>
                  <span data-custom-class="body_text">
                    how we process your information
                  </span>
                </span>
              </a>
              .
            </span>
          </span>
        </div>

        <div style={{ lineHeight: '1.5' }}>
          <br />
        </div>

        <div style={{ lineHeight: '1.5' }}>
          <span style={{ fontSize: '15px' }}>
            <span data-custom-class="body_text">
              <strong>
                In what situations and with which parties do we share personal
                information?
              </strong>{' '}
              We may share information in specific situations and with specific
              third parties. Learn more about{' '}
              <a
                data-custom-class="link"
                href="#whoshare"
                className="text-blue-600 hover:underline"
              >
                <span style={{ color: 'rgb(0, 58, 250)', fontSize: '15px' }}>
                  <span data-custom-class="body_text">
                    when and with whom we share your personal information
                  </span>
                </span>
              </a>
              .
            </span>
          </span>
        </div>

        <div style={{ lineHeight: '1.5' }}>
          <br />
        </div>

        <div style={{ lineHeight: '1.5' }}>
          <span style={{ fontSize: '15px' }}>
            <span data-custom-class="body_text">
              <strong>How do we keep your information safe?</strong> We have
              adequate organizational and technical processes and procedures in
              place to protect your personal information. However, no electronic
              transmission over the internet or information storage technology
              can be guaranteed to be 100% secure, so we cannot promise or
              guarantee that hackers, cybercriminals, or other unauthorized
              third parties will not be able to defeat our security and
              improperly collect, access, steal, or modify your information.
              Learn more about{' '}
              <a
                data-custom-class="link"
                href="#infosafe"
                className="text-blue-600 hover:underline"
              >
                <span style={{ color: 'rgb(0, 58, 250)', fontSize: '15px' }}>
                  <span data-custom-class="body_text">
                    how we keep your information safe
                  </span>
                </span>
              </a>
              .
            </span>
          </span>
        </div>

        <div style={{ lineHeight: '1.5' }}>
          <br />
        </div>

        <div style={{ lineHeight: '1.5' }}>
          <span style={{ fontSize: '15px' }}>
            <span data-custom-class="body_text">
              <strong>What are your rights?</strong> Depending on where you are
              located geographically, the applicable privacy law may mean you
              have certain rights regarding your personal information. Learn
              more about{' '}
              <a
                data-custom-class="link"
                href="#privacyrights"
                className="text-blue-600 hover:underline"
              >
                <span style={{ color: 'rgb(0, 58, 250)', fontSize: '15px' }}>
                  <span data-custom-class="body_text">your privacy rights</span>
                </span>
              </a>
              .
            </span>
          </span>
        </div>

        <div style={{ lineHeight: '1.5' }}>
          <br />
        </div>

        <div style={{ lineHeight: '1.5' }}>
          <span style={{ fontSize: '15px' }}>
            <span data-custom-class="body_text">
              <strong>How do you exercise your rights?</strong> The easiest way
              to exercise your rights is by visiting{' '}
              <a
                target="_blank"
                data-custom-class="link"
                href="https://Multitaxx.com"
                className="text-blue-600 hover:underline"
                rel="noreferrer"
              >
                https://Multitaxx.com
              </a>
              , or by contacting us. We will consider and act upon any request
              in accordance with applicable data protection laws.
            </span>
          </span>
        </div>

        <div style={{ lineHeight: '1.5' }}>
          <br />
        </div>

        <div style={{ lineHeight: '1.5' }}>
          <span style={{ fontSize: '15px' }}>
            <span data-custom-class="body_text">
              Want to learn more about what we do with any information we
              collect?{' '}
              <a
                data-custom-class="link"
                href="#toc"
                className="text-blue-600 hover:underline"
              >
                <span style={{ color: 'rgb(0, 58, 250)', fontSize: '15px' }}>
                  <span data-custom-class="body_text">
                    Review the Privacy Notice in full
                  </span>
                </span>
              </a>
              .
            </span>
          </span>
        </div>

        <div style={{ lineHeight: '1.5' }}>
          <br />
        </div>
        <div style={{ lineHeight: '1.5' }}>
          <br />
        </div>

        <div id="toc" style={{ lineHeight: '1.5' }}>
          <span style={{ fontSize: '15px' }}>
            <span style={{ color: 'rgb(127, 127, 127)' }}>
              <span style={{ color: 'rgb(0, 0, 0)' }}>
                <strong>
                  <span data-custom-class="heading_1">
                    <h2 className="text-2xl font-bold">TABLE OF CONTENTS</h2>
                  </span>
                </strong>
              </span>
            </span>
          </span>
        </div>

        <div style={{ lineHeight: '1.5' }}>
          <span style={{ fontSize: '15px' }}>
            <a
              data-custom-class="link"
              href="#infocollect"
              className="text-blue-600 hover:underline"
            >
              <span style={{ color: 'rgb(0, 58, 250)' }}>
                1. WHAT INFORMATION DO WE COLLECT?
              </span>
            </a>
          </span>
        </div>

        <div style={{ lineHeight: '1.5' }}>
          <span style={{ fontSize: '15px' }}>
            <a
              data-custom-class="link"
              href="#infouse"
              className="text-blue-600 hover:underline"
            >
              <span style={{ color: 'rgb(0, 58, 250)' }}>
                2. HOW DO WE PROCESS YOUR INFORMATION?
              </span>
            </a>
          </span>
        </div>

        <div style={{ lineHeight: '1.5' }}>
          <span style={{ fontSize: '15px' }}>
            <a
              data-custom-class="link"
              href="#whoshare"
              className="text-blue-600 hover:underline"
            >
              <span style={{ color: 'rgb(0, 58, 250)' }}>
                3. WHEN AND WITH WHOM DO WE SHARE YOUR PERSONAL INFORMATION?
              </span>
            </a>
          </span>
        </div>

        <div style={{ lineHeight: '1.5' }}>
          <span style={{ fontSize: '15px' }}>
            <a
              data-custom-class="link"
              href="#cookies"
              className="text-blue-600 hover:underline"
            >
              <span style={{ color: 'rgb(0, 58, 250)' }}>
                4. DO WE USE COOKIES AND OTHER TRACKING TECHNOLOGIES?
              </span>
            </a>
          </span>
        </div>

        <div style={{ lineHeight: '1.5' }}>
          <span style={{ fontSize: '15px' }}>
            <a
              data-custom-class="link"
              href="#inforetain"
              className="text-blue-600 hover:underline"
            >
              <span style={{ color: 'rgb(0, 58, 250)' }}>
                5. HOW LONG DO WE KEEP YOUR INFORMATION?
              </span>
            </a>
          </span>
        </div>

        <div style={{ lineHeight: '1.5' }}>
          <span style={{ fontSize: '15px' }}>
            <a
              data-custom-class="link"
              href="#infosafe"
              className="text-blue-600 hover:underline"
            >
              <span style={{ color: 'rgb(0, 58, 250)' }}>
                6. HOW DO WE KEEP YOUR INFORMATION SAFE?
              </span>
            </a>
          </span>
        </div>

        <div style={{ lineHeight: '1.5' }}>
          <span style={{ fontSize: '15px' }}>
            <a
              data-custom-class="link"
              href="#infominors"
              className="text-blue-600 hover:underline"
            >
              <span style={{ color: 'rgb(0, 58, 250)' }}>
                7. DO WE COLLECT INFORMATION FROM MINORS?
              </span>
            </a>
          </span>
        </div>

        <div style={{ lineHeight: '1.5' }}>
          <span style={{ fontSize: '15px' }}>
            <a
              data-custom-class="link"
              href="#privacyrights"
              className="text-blue-600 hover:underline"
            >
              <span style={{ color: 'rgb(0, 58, 250)' }}>
                8. WHAT ARE YOUR PRIVACY RIGHTS?
              </span>
            </a>
          </span>
        </div>

        <div style={{ lineHeight: '1.5' }}>
          <span style={{ fontSize: '15px' }}>
            <a
              data-custom-class="link"
              href="#DNT"
              className="text-blue-600 hover:underline"
            >
              <span style={{ color: 'rgb(0, 58, 250)' }}>
                9. CONTROLS FOR DO-NOT-TRACK FEATURES
              </span>
            </a>
          </span>
        </div>

        <div style={{ lineHeight: '1.5' }}>
          <span style={{ fontSize: '15px' }}>
            <a
              data-custom-class="link"
              href="#uslaws"
              className="text-blue-600 hover:underline"
            >
              <span style={{ color: 'rgb(0, 58, 250)' }}>
                10. DO UNITED STATES RESIDENTS HAVE SPECIFIC PRIVACY RIGHTS?
              </span>
            </a>
          </span>
        </div>

        <div style={{ lineHeight: '1.5' }}>
          <span style={{ fontSize: '15px' }}>
            <a
              data-custom-class="link"
              href="#policyupdates"
              className="text-blue-600 hover:underline"
            >
              <span style={{ color: 'rgb(0, 58, 250)' }}>
                11. DO WE MAKE UPDATES TO THIS NOTICE?
              </span>
            </a>
          </span>
        </div>

        <div style={{ lineHeight: '1.5' }}>
          <a
            data-custom-class="link"
            href="#contact"
            className="text-blue-600 hover:underline"
          >
            <span style={{ color: 'rgb(0, 58, 250)', fontSize: '15px' }}>
              12. HOW CAN YOU CONTACT US ABOUT THIS NOTICE?
            </span>
          </a>
        </div>

        <div style={{ lineHeight: '1.5' }}>
          <a
            data-custom-class="link"
            href="#request"
            className="text-blue-600 hover:underline"
          >
            <span style={{ color: 'rgb(0, 58, 250)' }}>
              13. HOW CAN YOU REVIEW, UPDATE, OR DELETE THE DATA WE COLLECT FROM
              YOU?
            </span>
          </a>
        </div>

        <div style={{ lineHeight: '1.5' }}>
          <br />
        </div>
        <div style={{ lineHeight: '1.5' }}>
          <br />
        </div>

        <div id="infocollect" style={{ lineHeight: '1.5' }}>
          <span style={{ color: 'rgb(0, 0, 0)' }}>
            <span style={{ color: 'rgb(0, 0, 0)', fontSize: '15px' }}>
              <span style={{ fontSize: '15px', color: 'rgb(0, 0, 0)' }}>
                <span style={{ fontSize: '15px', color: 'rgb(0, 0, 0)' }}>
                  <span id="control" style={{ color: 'rgb(0, 0, 0)' }}>
                    <strong>
                      <span data-custom-class="heading_1">
                        <h2 className="text-2xl font-bold">
                          1. WHAT INFORMATION DO WE COLLECT?
                        </h2>
                      </span>
                    </strong>
                  </span>
                </span>
              </span>
            </span>
          </span>

          <span
            data-custom-class="heading_2"
            id="personalinfo"
            style={{ color: 'rgb(0, 0, 0)' }}
          >
            <span style={{ fontSize: '15px' }}>
              <strong>
                <h3 className="text-xl font-bold">
                  Personal information you disclose to us
                </h3>
              </strong>
            </span>
          </span>

          <span style={{ color: 'rgb(127, 127, 127)' }}>
            <span style={{ color: 'rgb(89, 89, 89)', fontSize: '15px' }}>
              <span data-custom-class="body_text">
                <span style={{ fontSize: '15px', color: 'rgb(89, 89, 89)' }}>
                  <span style={{ fontSize: '15px', color: 'rgb(89, 89, 89)' }}>
                    <span data-custom-class="body_text">
                      <strong>
                        <em>In Short:</em>
                      </strong>
                    </span>
                  </span>
                </span>
                <span data-custom-class="body_text">
                  <span style={{ fontSize: '15px', color: 'rgb(89, 89, 89)' }}>
                    <span
                      style={{ fontSize: '15px', color: 'rgb(89, 89, 89)' }}
                    >
                      <span data-custom-class="body_text">
                        <strong>
                          <em> </em>
                        </strong>
                        <em>
                          We collect personal information that you provide to
                          us.
                        </em>
                      </span>
                    </span>
                  </span>
                </span>
              </span>
            </span>
          </span>
        </div>

        <div style={{ lineHeight: '1.5' }}>
          <br />
        </div>

        <div style={{ lineHeight: '1.5' }}>
          <span style={{ fontSize: '15px', color: 'rgb(89, 89, 89)' }}>
            <span style={{ fontSize: '15px', color: 'rgb(89, 89, 89)' }}>
              <span data-custom-class="body_text">
                We collect personal information that you voluntarily provide to
                us when you register on the Services, express an interest in
                obtaining information about us or our products and Services,
                when you participate in activities on the Services, or otherwise
                when you contact us.
              </span>
            </span>
          </span>
        </div>

        <div style={{ lineHeight: '1.5' }}>
          <br />
        </div>

        <div style={{ lineHeight: '1.5' }}>
          <span style={{ fontSize: '15px', color: 'rgb(89, 89, 89)' }}>
            <span style={{ fontSize: '15px', color: 'rgb(89, 89, 89)' }}>
              <span data-custom-class="body_text">
                <strong>Personal Information Provided by You.</strong> The
                personal information that we collect depends on the context of
                your interactions with us and the Services, the choices you
                make, and the products and features you use. The personal
                information we collect may include the following:
              </span>
            </span>
          </span>
        </div>

        <ul>
          <li data-custom-class="body_text" style={{ lineHeight: '1.5' }}>
            <span style={{ fontSize: '15px', color: 'rgb(89, 89, 89)' }}>
              <span style={{ fontSize: '15px', color: 'rgb(89, 89, 89)' }}>
                <span data-custom-class="body_text">names</span>
              </span>
            </span>
          </li>
        </ul>

        <ul>
          <li data-custom-class="body_text" style={{ lineHeight: '1.5' }}>
            <span style={{ fontSize: '15px', color: 'rgb(89, 89, 89)' }}>
              <span style={{ fontSize: '15px', color: 'rgb(89, 89, 89)' }}>
                <span data-custom-class="body_text">phone numbers</span>
              </span>
            </span>
          </li>
        </ul>

        <ul>
          <li data-custom-class="body_text" style={{ lineHeight: '1.5' }}>
            <span style={{ fontSize: '15px', color: 'rgb(89, 89, 89)' }}>
              <span style={{ fontSize: '15px', color: 'rgb(89, 89, 89)' }}>
                <span data-custom-class="body_text">email addresses</span>
              </span>
            </span>
          </li>
        </ul>

        <ul>
          <li data-custom-class="body_text" style={{ lineHeight: '1.5' }}>
            <span style={{ fontSize: '15px', color: 'rgb(89, 89, 89)' }}>
              <span style={{ fontSize: '15px', color: 'rgb(89, 89, 89)' }}>
                <span data-custom-class="body_text">mailing addresses</span>
              </span>
            </span>
          </li>
        </ul>

        <ul>
          <li data-custom-class="body_text" style={{ lineHeight: '1.5' }}>
            <span style={{ fontSize: '15px', color: 'rgb(89, 89, 89)' }}>
              <span style={{ fontSize: '15px', color: 'rgb(89, 89, 89)' }}>
                <span data-custom-class="body_text">job titles</span>
              </span>
            </span>
          </li>
        </ul>

        <div id="sensitiveinfo" style={{ lineHeight: '1.5' }}>
          <span style={{ fontSize: '15px' }}>
            <span data-custom-class="body_text">
              <strong>Sensitive Information.</strong> When necessary, with your
              consent or as otherwise permitted by applicable law, we process
              the following categories of sensitive information:
            </span>
          </span>
        </div>

        <ul>
          <li data-custom-class="body_text" style={{ lineHeight: '1.5' }}>
            <span style={{ fontSize: '15px' }}>
              <span data-custom-class="body_text">
                social security numbers or other government identifiers
              </span>
            </span>
          </li>
        </ul>

        <ul>
          <li data-custom-class="body_text" style={{ lineHeight: '1.5' }}>
            <span style={{ fontSize: '15px' }}>
              <span data-custom-class="body_text">financial data</span>
            </span>
          </li>
        </ul>

        <div style={{ lineHeight: '1.5' }}>
          <span data-custom-class="body_text">
            <span style={{ fontSize: '15px' }}>
              <strong>Application Data.</strong> If you use our application(s),
              we also may collect the following information if you choose to
              provide us with access or permission:
            </span>
          </span>
        </div>

        <ul>
          <li data-custom-class="body_text" style={{ lineHeight: '1.5' }}>
            <span style={{ fontSize: '15px' }}>
              <span data-custom-class="body_text">
                <em>Mobile Device Data.</em> We automatically collect device
                information (such as your mobile device ID, model, and
                manufacturer), operating system, version information and system
                configuration information, device and application identification
                numbers, browser type and version, hardware model Internet
                service provider and/or mobile carrier, and Internet Protocol
                (IP) address (or proxy server). If you are using our
                application(s), we may also collect information about the phone
                network associated with your mobile device, your mobile
                device&apos;s operating system or platform, the type of mobile
                device you use, your mobile device&apos;s unique device ID, and
                information about the features of our application(s) you
                accessed.
              </span>
            </span>
          </li>
        </ul>

        <ul>
          <li data-custom-class="body_text" style={{ lineHeight: '1.5' }}>
            <span style={{ fontSize: '15px' }}>
              <span data-custom-class="body_text">
                <em>Push Notifications.</em> We may request to send you push
                notifications regarding your account or certain features of the
                application(s). If you wish to opt out from receiving these
                types of communications, you may turn them off in your
                device&apos;s settings.
              </span>
            </span>
          </li>
        </ul>

        <div style={{ lineHeight: '1.5' }}>
          <span style={{ fontSize: '15px' }}>
            <span data-custom-class="body_text">
              This information is primarily needed to maintain the security and
              operation of our application(s), for troubleshooting, and for our
              internal analytics and reporting purposes.
            </span>
          </span>
        </div>

        <div style={{ lineHeight: '1.5' }}>
          <br />
        </div>

        <div style={{ lineHeight: '1.5' }}>
          <span style={{ fontSize: '15px', color: 'rgb(89, 89, 89)' }}>
            <span style={{ fontSize: '15px', color: 'rgb(89, 89, 89)' }}>
              <span data-custom-class="body_text">
                All personal information that you provide to us must be true,
                complete, and accurate, and you must notify us of any changes to
                such personal information.
              </span>
            </span>
          </span>
        </div>

        <div style={{ lineHeight: '1.5' }}>
          <br />
        </div>

        <div style={{ lineHeight: '1.5' }}>
          <span style={{ fontSize: '15px' }}>
            <strong>
              <span data-custom-class="heading_2">
                <h3 className="text-lg font-bold">Google API</h3>
              </span>
            </strong>
            <span data-custom-class="body_text">
              Our use of information received from Google APIs will adhere to{' '}
              <a
                data-custom-class="link"
                href="https://developers.google.com/terms/api-services-user-data-policy"
                rel="noopener noreferrer"
                target="_blank"
                className="text-blue-600 hover:underline"
              >
                Google API Services User Data Policy
              </a>
              , including the{' '}
              <a
                data-custom-class="link"
                href="https://developers.google.com/terms/api-services-user-data-policy#limited-use"
                rel="noopener noreferrer"
                target="_blank"
                className="text-blue-600 hover:underline"
              >
                Limited Use requirements
              </a>
              .
            </span>
          </span>
        </div>

        <div>
          <span style={{ fontSize: '15px' }}>
            <br />
          </span>
        </div>
        <div style={{ lineHeight: '1.5' }}>
          <br />
        </div>

        <div id="infouse" style={{ lineHeight: '1.5' }}>
          <span style={{ color: 'rgb(127, 127, 127)' }}>
            <span style={{ color: 'rgb(89, 89, 89)', fontSize: '15px' }}>
              <span style={{ fontSize: '15px', color: 'rgb(89, 89, 89)' }}>
                <span style={{ fontSize: '15px', color: 'rgb(89, 89, 89)' }}>
                  <span id="control" style={{ color: 'rgb(0, 0, 0)' }}>
                    <strong>
                      <span data-custom-class="heading_1">
                        <h2 className="text-2xl font-bold">
                          2. HOW DO WE PROCESS YOUR INFORMATION?
                        </h2>
                      </span>
                    </strong>
                  </span>
                </span>
              </span>
              <span data-custom-class="body_text">
                <span style={{ fontSize: '15px', color: 'rgb(89, 89, 89)' }}>
                  <span style={{ fontSize: '15px', color: 'rgb(89, 89, 89)' }}>
                    <span data-custom-class="body_text">
                      <strong>
                        <em>In Short: </em>
                      </strong>
                      <em>
                        We process your information to provide, improve, and
                        administer our Services, communicate with you, for
                        security and fraud prevention, and to comply with law.
                        We may also process your information for other purposes
                        with your consent.
                      </em>
                    </span>
                  </span>
                </span>
              </span>
            </span>
          </span>
        </div>

        <div style={{ lineHeight: '1.5' }}>
          <br />
        </div>

        <div style={{ lineHeight: '1.5' }}>
          <span style={{ fontSize: '15px', color: 'rgb(89, 89, 89)' }}>
            <span style={{ fontSize: '15px', color: 'rgb(89, 89, 89)' }}>
              <span data-custom-class="body_text">
                <strong>
                  We process your personal information for a variety of reasons,
                  depending on how you interact with our Services, including:
                </strong>
              </span>
            </span>
          </span>
        </div>

        <ul>
          <li data-custom-class="body_text" style={{ lineHeight: '1.5' }}>
            <span style={{ fontSize: '15px', color: 'rgb(89, 89, 89)' }}>
              <span style={{ fontSize: '15px', color: 'rgb(89, 89, 89)' }}>
                <span data-custom-class="body_text">
                  <strong>
                    To facilitate account creation and authentication and
                    otherwise manage user accounts.{' '}
                  </strong>
                  We may process your information so you can create and log in
                  to your account, as well as keep your account in working
                  order.
                </span>
              </span>
            </span>
          </li>
        </ul>

        <ul>
          <li data-custom-class="body_text" style={{ lineHeight: '1.5' }}>
            <span style={{ fontSize: '15px', color: 'rgb(89, 89, 89)' }}>
              <span style={{ fontSize: '15px', color: 'rgb(89, 89, 89)' }}>
                <span data-custom-class="body_text">
                  <strong>
                    To deliver and facilitate delivery of services to the
                    user.{' '}
                  </strong>
                  We may process your information to provide you with the
                  requested service.
                </span>
              </span>
            </span>
          </li>
        </ul>

        <div style={{ lineHeight: '1.5' }}>
          <br />
        </div>

        <div id="whoshare" style={{ lineHeight: '1.5' }}>
          <span style={{ color: 'rgb(127, 127, 127)' }}>
            <span style={{ color: 'rgb(89, 89, 89)', fontSize: '15px' }}>
              <span style={{ fontSize: '15px', color: 'rgb(89, 89, 89)' }}>
                <span style={{ fontSize: '15px', color: 'rgb(89, 89, 89)' }}>
                  <span id="control" style={{ color: 'rgb(0, 0, 0)' }}>
                    <strong>
                      <span data-custom-class="heading_1">
                        <h2 className="text-2xl font-bold">
                          3. WHEN AND WITH WHOM DO WE SHARE YOUR PERSONAL
                          INFORMATION?
                        </h2>
                      </span>
                    </strong>
                  </span>
                </span>
              </span>
            </span>
          </span>
          <span style={{ fontSize: '15px', color: 'rgb(89, 89, 89)' }}>
            <span style={{ fontSize: '15px', color: 'rgb(89, 89, 89)' }}>
              <span data-custom-class="body_text">
                <strong>
                  <em>In Short:</em>
                </strong>
                <em>
                  {' '}
                  We may share information in specific situations described in
                  this section and/or with the following third parties.
                </em>
              </span>
            </span>
          </span>
        </div>

        <div style={{ lineHeight: '1.5' }}>
          <br />
        </div>

        <div style={{ lineHeight: '1.5' }}>
          <span style={{ fontSize: '15px' }}>
            <span data-custom-class="body_text">
              We may need to share your personal information in the following
              situations:
            </span>
          </span>
        </div>

        <ul>
          <li data-custom-class="body_text" style={{ lineHeight: '1.5' }}>
            <span style={{ fontSize: '15px' }}>
              <span data-custom-class="body_text">
                <strong>Business Transfers.</strong> We may share or transfer
                your information in connection with, or during negotiations of,
                any merger, sale of company assets, financing, or acquisition of
                all or a portion of our business to another company.
              </span>
            </span>
          </li>
        </ul>

        <div style={{ lineHeight: '1.5' }}>
          <br />
        </div>

        <div id="cookies" style={{ lineHeight: '1.5' }}>
          <span style={{ color: 'rgb(127, 127, 127)' }}>
            <span style={{ color: 'rgb(89, 89, 89)', fontSize: '15px' }}>
              <span style={{ fontSize: '15px', color: 'rgb(89, 89, 89)' }}>
                <span style={{ fontSize: '15px', color: 'rgb(89, 89, 89)' }}>
                  <span id="control" style={{ color: 'rgb(0, 0, 0)' }}>
                    <strong>
                      <span data-custom-class="heading_1">
                        <h2 className="text-2xl font-bold">
                          4. DO WE USE COOKIES AND OTHER TRACKING TECHNOLOGIES?
                        </h2>
                      </span>
                    </strong>
                  </span>
                </span>
              </span>
            </span>
          </span>
          <span style={{ fontSize: '15px', color: 'rgb(89, 89, 89)' }}>
            <span style={{ fontSize: '15px', color: 'rgb(89, 89, 89)' }}>
              <span data-custom-class="body_text">
                <strong>
                  <em>In Short:</em>
                </strong>
                <em>
                  {' '}
                  We may use cookies and other tracking technologies to collect
                  and store your information.
                </em>
              </span>
            </span>
          </span>
        </div>

        <div style={{ lineHeight: '1.5' }}>
          <br />
        </div>

        <div style={{ lineHeight: '1.5' }}>
          <span style={{ fontSize: '15px', color: 'rgb(89, 89, 89)' }}>
            <span style={{ fontSize: '15px', color: 'rgb(89, 89, 89)' }}>
              <span data-custom-class="body_text">
                We may use cookies and similar tracking technologies (like web
                beacons and pixels) to gather information when you interact with
                our Services. Some online tracking technologies help us maintain
                the security of our Services and your account, prevent crashes,
                fix bugs, save your preferences, and assist with basic site
                functions.
              </span>
            </span>
          </span>
        </div>

        <div style={{ lineHeight: '1.5' }}>
          <br />
        </div>

        <div style={{ lineHeight: '1.5' }}>
          <span style={{ fontSize: '15px', color: 'rgb(89, 89, 89)' }}>
            <span style={{ fontSize: '15px', color: 'rgb(89, 89, 89)' }}>
              <span data-custom-class="body_text">
                We also permit third parties and service providers to use online
                tracking technologies on our Services for analytics and
                advertising, including to help manage and display
                advertisements, to tailor advertisements to your interests, or
                to send abandoned shopping cart reminders (depending on your
                communication preferences). The third parties and service
                providers use their technology to provide advertising about
                products and services tailored to your interests which may
                appear either on our Services or on other websites.
              </span>
            </span>
          </span>
        </div>

        <div style={{ lineHeight: '1.5' }}>
          <br />
        </div>

        <div style={{ lineHeight: '1.5' }}>
          <span style={{ fontSize: '15px', color: 'rgb(89, 89, 89)' }}>
            <span style={{ fontSize: '15px', color: 'rgb(89, 89, 89)' }}>
              <span data-custom-class="body_text">
                Specific information about how we use such technologies and how
                you can refuse certain cookies is set out in our Cookie Notice.
              </span>
            </span>
          </span>
        </div>

        <div style={{ lineHeight: '1.5' }}>
          <br />
        </div>

        <div style={{ lineHeight: '1.5' }}>
          <span style={{ fontSize: '15px' }}>
            <strong>
              <span data-custom-class="heading_2">
                <h3 className="text-lg font-bold">Google Analytics</h3>
              </span>
            </strong>
            <span data-custom-class="body_text">
              We may share your information with Google Analytics to track and
              analyze the use of the Services. The Google Analytics Advertising
              Features that we may use include: Google Analytics Demographics
              and Interests Reporting. To opt out of being tracked by Google
              Analytics across the Services, visit{' '}
              <a
                data-custom-class="link"
                href="https://tools.google.com/dlpage/gaoptout"
                rel="noopener noreferrer"
                target="_blank"
                className="text-blue-600 hover:underline"
              >
                https://tools.google.com/dlpage/gaoptout
              </a>
              . You can opt out of Google Analytics Advertising Features through{' '}
              <a
                data-custom-class="link"
                href="https://adssettings.google.com/"
                rel="noopener noreferrer"
                target="_blank"
                className="text-blue-600 hover:underline"
              >
                Ads Settings
              </a>
              and Ad Settings for mobile apps. Other opt out means include{' '}
              <a
                data-custom-class="link"
                href="http://optout.networkadvertising.org/"
                rel="noopener noreferrer"
                target="_blank"
                className="text-blue-600 hover:underline"
              >
                http://optout.networkadvertising.org/
              </a>
              and{' '}
              <a
                data-custom-class="link"
                href="http://www.networkadvertising.org/mobile-choice"
                rel="noopener noreferrer"
                target="_blank"
                className="text-blue-600 hover:underline"
              >
                http://www.networkadvertising.org/mobile-choice
              </a>
              . For more information on the privacy practices of Google, please
              visit the{' '}
              <a
                data-custom-class="link"
                href="https://policies.google.com/privacy"
                rel="noopener noreferrer"
                target="_blank"
                className="text-blue-600 hover:underline"
              >
                Google Privacy & Terms page
              </a>
              .
            </span>
          </span>
        </div>

        <div style={{ lineHeight: '1.5' }}>
          <br />
        </div>

        <div id="inforetain" style={{ lineHeight: '1.5' }}>
          <span style={{ color: 'rgb(127, 127, 127)' }}>
            <span style={{ color: 'rgb(89, 89, 89)', fontSize: '15px' }}>
              <span style={{ fontSize: '15px', color: 'rgb(89, 89, 89)' }}>
                <span style={{ fontSize: '15px', color: 'rgb(89, 89, 89)' }}>
                  <span id="control" style={{ color: 'rgb(0, 0, 0)' }}>
                    <strong>
                      <span data-custom-class="heading_1">
                        <h2 className="text-2xl font-bold">
                          5. HOW LONG DO WE KEEP YOUR INFORMATION?
                        </h2>
                      </span>
                    </strong>
                  </span>
                </span>
              </span>
            </span>
          </span>
          <span style={{ fontSize: '15px', color: 'rgb(89, 89, 89)' }}>
            <span style={{ fontSize: '15px', color: 'rgb(89, 89, 89)' }}>
              <span data-custom-class="body_text">
                <strong>
                  <em>In Short: </em>
                </strong>
                <em>
                  We keep your information for as long as necessary to fulfill
                  the purposes outlined in this Privacy Notice unless otherwise
                  required by law.
                </em>
              </span>
            </span>
          </span>
        </div>

        <div style={{ lineHeight: '1.5' }}>
          <br />
        </div>

        <div style={{ lineHeight: '1.5' }}>
          <span style={{ fontSize: '15px', color: 'rgb(89, 89, 89)' }}>
            <span style={{ fontSize: '15px', color: 'rgb(89, 89, 89)' }}>
              <span data-custom-class="body_text">
                We will only keep your personal information for as long as it is
                necessary for the purposes set out in this Privacy Notice,
                unless a longer retention period is required or permitted by law
                (such as tax, accounting, or other legal requirements). No
                purpose in this notice will require us keeping your personal
                information for longer than the period of time in which users
                have an account with us.
              </span>
            </span>
          </span>
        </div>

        <div style={{ lineHeight: '1.5' }}>
          <br />
        </div>

        <div style={{ lineHeight: '1.5' }}>
          <span style={{ fontSize: '15px', color: 'rgb(89, 89, 89)' }}>
            <span style={{ fontSize: '15px', color: 'rgb(89, 89, 89)' }}>
              <span data-custom-class="body_text">
                When we have no ongoing legitimate business need to process your
                personal information, we will either delete or anonymize such
                information, or, if this is not possible (for example, because
                your personal information has been stored in backup archives),
                then we will securely store your personal information and
                isolate it from any further processing until deletion is
                possible.
              </span>
            </span>
          </span>
        </div>

        <div style={{ lineHeight: '1.5' }}>
          <br />
        </div>

        <div id="infosafe" style={{ lineHeight: '1.5' }}>
          <span style={{ color: 'rgb(127, 127, 127)' }}>
            <span style={{ color: 'rgb(89, 89, 89)', fontSize: '15px' }}>
              <span style={{ fontSize: '15px', color: 'rgb(89, 89)' }}>
                <span style={{ fontSize: '15px', color: 'rgb(89, 89, 89)' }}>
                  <span id="control" style={{ color: 'rgb(0, 0, 0)' }}>
                    <strong>
                      <span data-custom-class="heading_1">
                        <h2 className="text-2xl font-bold">
                          6. HOW DO WE KEEP YOUR INFORMATION SAFE?
                        </h2>
                      </span>
                    </strong>
                  </span>
                </span>
              </span>
            </span>
          </span>
          <span style={{ fontSize: '15px', color: 'rgb(89, 89, 89)' }}>
            <span style={{ fontSize: '15px', color: 'rgb(89, 89, 89)' }}>
              <span data-custom-class="body_text">
                <strong>
                  <em>In Short: </em>
                </strong>
                <em>
                  We aim to protect your personal information through a system
                  of organizational and technical security measures.
                </em>
              </span>
            </span>
          </span>
        </div>

        <div style={{ lineHeight: '1.5' }}>
          <br />
        </div>

        <div style={{ lineHeight: '1.5' }}>
          <span style={{ fontSize: '15px', color: 'rgb(89, 89, 89)' }}>
            <span style={{ fontSize: '15px', color: 'rgb(89, 89, 89)' }}>
              <span data-custom-class="body_text">
                We have implemented appropriate and reasonable technical and
                organizational security measures designed to protect the
                security of any personal information we process. However,
                despite our safeguards and efforts to secure your information,
                no electronic transmission over the Internet or information
                storage technology can be guaranteed to be 100% secure, so we
                cannot promise or guarantee that hackers, cybercriminals, or
                other unauthorized third parties will not be able to defeat our
                security and improperly collect, access, steal, or modify your
                information. Although we will do our best to protect your
                personal information, transmission of personal information to
                and from our Services is at your own risk. You should only
                access the Services within a secure environment.
              </span>
            </span>
          </span>
        </div>

        <div style={{ lineHeight: '1.5' }}>
          <br />
        </div>

        <div id="infominors" style={{ lineHeight: '1.5' }}>
          <span style={{ color: 'rgb(127, 127, 127)' }}>
            <span style={{ color: 'rgb(89, 89, 89)', fontSize: '15px' }}>
              <span style={{ fontSize: '15px', color: 'rgb(89, 89, 89)' }}>
                <span style={{ fontSize: '15px', color: 'rgb(89, 89, 89)' }}>
                  <span id="control" style={{ color: 'rgb(0, 0, 0)' }}>
                    <strong>
                      <span data-custom-class="heading_1">
                        <h2 className="text-2xl font-bold">
                          7. DO WE COLLECT INFORMATION FROM MINORS?
                        </h2>
                      </span>
                    </strong>
                  </span>
                </span>
              </span>
            </span>
          </span>
          <span style={{ fontSize: '15px', color: 'rgb(89, 89, 89)' }}>
            <span style={{ fontSize: '15px', color: 'rgb(89, 89, 89)' }}>
              <span data-custom-class="body_text">
                <strong>
                  <em>In Short:</em>
                </strong>
                <em>
                  {' '}
                  We do not knowingly collect data from or market to children
                  under 18 years of age.
                </em>
              </span>
            </span>
          </span>
        </div>

        <div style={{ lineHeight: '1.5' }}>
          <br />
        </div>

        <div style={{ lineHeight: '1.5' }}>
          <span style={{ fontSize: '15px', color: 'rgb(89, 89, 89)' }}>
            <span style={{ fontSize: '15px', color: 'rgb(89, 89, 89)' }}>
              <span data-custom-class="body_text">
                We do not knowingly collect, solicit data from, or market to
                children under 18 years of age, nor do we knowingly sell such
                personal information. By using the Services, you represent that
                you are at least 18 or that you are the parent or guardian of
                such a minor and consent to such minor dependent&apos;s use of
                the Services. If we learn that personal information from users
                less than 18 years of age has been collected, we will deactivate
                the account and take reasonable measures to promptly delete such
                data from our records. If you become aware of any data we may
                have collected from children under age 18, please contact us at{' '}
                <a
                  target="_blank"
                  data-custom-class="link"
                  href="mailto:info@multitaxx.com"
                  className="text-blue-600 hover:underline"
                  rel="noreferrer"
                >
                  info@multitaxx.com
                </a>
                .
              </span>
            </span>
          </span>
        </div>

        <div style={{ lineHeight: '1.5' }}>
          <br />
        </div>

        <div id="privacyrights" style={{ lineHeight: '1.5' }}>
          <span style={{ color: 'rgb(127, 127, 127)' }}>
            <span style={{ color: 'rgb(89, 89, 89)', fontSize: '15px' }}>
              <span style={{ fontSize: '15px', color: 'rgb(89, 89, 89)' }}>
                <span style={{ fontSize: '15px', color: 'rgb(89, 89, 89)' }}>
                  <span id="control" style={{ color: 'rgb(0, 0, 0)' }}>
                    <strong>
                      <span data-custom-class="heading_1">
                        <h2 className="text-2xl font-bold">
                          8. WHAT ARE YOUR PRIVACY RIGHTS?
                        </h2>
                      </span>
                    </strong>
                  </span>
                </span>
              </span>
            </span>
          </span>
          <span style={{ fontSize: '15px', color: 'rgb(89, 89, 89)' }}>
            <span style={{ fontSize: '15px', color: 'rgb(89, 89, 89)' }}>
              <span data-custom-class="body_text">
                <strong>
                  <em>In Short: </em>
                </strong>
                <em>
                  You may review, change, or terminate your account at any time,
                  depending on your country, province, or state of residence.
                </em>
              </span>
            </span>
          </span>
        </div>

        <div style={{ lineHeight: '1.5' }}>
          <br />
        </div>

        <div id="withdrawconsent" style={{ lineHeight: '1.5' }}>
          <span style={{ fontSize: '15px', color: 'rgb(89, 89, 89)' }}>
            <span style={{ fontSize: '15px', color: 'rgb(89, 89, 89)' }}>
              <span data-custom-class="body_text">
                <strong>
                  <u>Withdrawing your consent:</u>
                </strong>{' '}
                If we are relying on your consent to process your personal
                information, which may be express and/or implied consent
                depending on the applicable law, you have the right to withdraw
                your consent at any time. You can withdraw your consent at any
                time by contacting us by using the contact details provided in
                the section{' '}
                <a
                  data-custom-class="link"
                  href="#contact"
                  className="text-blue-600 hover:underline"
                >
                  <span style={{ fontSize: '15px', color: 'rgb(0, 58, 250)' }}>
                    <span
                      style={{ fontSize: '15px', color: 'rgb(0, 58, 250)' }}
                    >
                      <span data-custom-class="body_text">
                        HOW CAN YOU CONTACT US ABOUT THIS NOTICE?
                      </span>
                    </span>
                  </span>
                </a>{' '}
                below.
              </span>
            </span>
          </span>
        </div>

        <div style={{ lineHeight: '1.5' }}>
          <br />
        </div>

        <div style={{ lineHeight: '1.5' }}>
          <span style={{ fontSize: '15px' }}>
            <span data-custom-class="body_text">
              However, please note that this will not affect the lawfulness of
              the processing before its withdrawal nor, when applicable law
              allows, will it affect the processing of your personal information
              conducted in reliance on lawful processing grounds other than
              consent.
            </span>
          </span>
          <span style={{ fontSize: '15px' }}>
            <span data-custom-class="heading_2">
              <strong>
                <h3 className="text-lg font-bold">Account Information</h3>
              </strong>
            </span>
          </span>
          <span data-custom-class="body_text">
            <span style={{ fontSize: '15px' }}>
              If you would at any time like to review or change the information
              in your account or terminate your account, you can:
            </span>
          </span>
        </div>

        <ul>
          <li data-custom-class="body_text" style={{ lineHeight: '1.5' }}>
            <span data-custom-class="body_text">
              <span style={{ fontSize: '15px' }}>
                Log in to your account settings and update your user account.
              </span>
            </span>
          </li>
        </ul>

        <ul>
          <li data-custom-class="body_text" style={{ lineHeight: '1.5' }}>
            <span data-custom-class="body_text">
              <span style={{ fontSize: '15px' }}>
                Contact us using the contact information provided.
              </span>
            </span>
          </li>
        </ul>

        <div style={{ lineHeight: '1.5' }}>
          <span style={{ fontSize: '15px' }}>
            <span data-custom-class="body_text">
              Upon your request to terminate your account, we will deactivate or
              delete your account and information from our active databases.
              However, we may retain some information in our files to prevent
              fraud, troubleshoot problems, assist with any investigations,
              enforce our legal terms and/or comply with applicable legal
              requirements.
            </span>
          </span>
        </div>

        <div style={{ lineHeight: '1.5' }}>
          <br />
        </div>

        <div style={{ lineHeight: '1.5' }}>
          <span data-custom-class="body_text">
            <span style={{ fontSize: '15px' }}>
              If you have questions or comments about your privacy rights, you
              may email us at{' '}
              <a
                target="_blank"
                data-custom-class="link"
                href="mailto:info@multitaxx.com"
                className="text-blue-600 hover:underline"
                rel="noreferrer"
              >
                info@multitaxx.com
              </a>
              .
            </span>
          </span>
        </div>

        <div style={{ lineHeight: '1.5' }}>
          <br />
        </div>

        <div id="DNT" style={{ lineHeight: '1.5' }}>
          <span style={{ color: 'rgb(127, 127, 127)' }}>
            <span style={{ color: 'rgb(89, 89, 89)', fontSize: '15px' }}>
              <span style={{ fontSize: '15px', color: 'rgb(89, 89, 89)' }}>
                <span style={{ fontSize: '15px', color: 'rgb(89, 89, 89)' }}>
                  <span id="control" style={{ color: 'rgb(0, 0, 0)' }}>
                    <strong>
                      <span data-custom-class="heading_1">
                        <h2 className="text-2xl font-bold">
                          9. CONTROLS FOR DO-NOT-TRACK FEATURES
                        </h2>
                      </span>
                    </strong>
                  </span>
                </span>
              </span>
            </span>
          </span>
          <span style={{ fontSize: '15px', color: 'rgb(89, 89, 89)' }}>
            <span style={{ fontSize: '15px', color: 'rgb(89, 89, 89)' }}>
              <span data-custom-class="body_text">
                Most web browsers and some mobile operating systems and mobile
                applications include a Do-Not-Track (&quot;DNT&quot;) feature or
                setting you can activate to signal your privacy preference not
                to have data about your online browsing activities monitored and
                collected. At this stage, no uniform technology standard for
                recognizing and implementing DNT signals has been finalized. As
                such, we do not currently respond to DNT browser signals or any
                other mechanism that automatically communicates your choice not
                to be tracked online. If a standard for online tracking is
                adopted that we must follow in the future, we will inform you
                about that practice in a revised version of this Privacy Notice.
              </span>
            </span>
          </span>
        </div>

        <div style={{ lineHeight: '1.5' }}>
          <span style={{ fontSize: '15px' }}>
            <br />
          </span>
        </div>

        <div style={{ lineHeight: '1.5' }}>
          <span style={{ fontSize: '15px' }}>
            <span data-custom-class="body_text">
              California law requires us to let you know how we respond to web
              browser DNT signals. Because there currently is not an industry or
              legal standard for recognizing or honoring DNT signals, we do not
              respond to them at this time.
            </span>
          </span>
        </div>

        <div style={{ lineHeight: '1.5' }}>
          <br />
        </div>

        <div id="uslaws" style={{ lineHeight: '1.5' }}>
          <span style={{ color: 'rgb(127, 127, 127)' }}>
            <span style={{ color: 'rgb(89, 89, 89)', fontSize: '15px' }}>
              <span style={{ fontSize: '15px', color: 'rgb(89, 89, 89)' }}>
                <span style={{ fontSize: '15px', color: 'rgb(89, 89, 89)' }}>
                  <span id="control" style={{ color: 'rgb(0, 0)' }}>
                    <strong>
                      <span data-custom-class="heading_1">
                        <h2 className="text-2xl font-bold">
                          10. DO UNITED STATES RESIDENTS HAVE SPECIFIC PRIVACY
                          RIGHTS?
                        </h2>
                      </span>
                    </strong>
                  </span>
                </span>
              </span>
            </span>
          </span>
          <span style={{ fontSize: '15px', color: 'rgb(89, 89, 89)' }}>
            <span style={{ fontSize: '15px', color: 'rgb(89, 89, 89)' }}>
              <span data-custom-class="body_text">
                <strong>
                  <em>In Short: </em>
                </strong>
                <em>
                  If you are a resident of California, Colorado, Connecticut,
                  Delaware, Florida, Indiana, Iowa, Kentucky, Maryland,
                  Minnesota, Montana, Nebraska, New Hampshire, New Jersey,
                  Oregon, Rhode Island, Tennessee, Texas, Utah, or Virginia, you
                  may have the right to request access to and receive details
                  about the personal information we maintain about you and how
                  we have processed it, correct inaccuracies, get a copy of, or
                  delete your personal information. You may also have the right
                  to withdraw your consent to our processing of your personal
                  information. These rights may be limited in some circumstances
                  by applicable law. More information is provided below.
                </em>
              </span>
              <strong>
                <span data-custom-class="heading_2">
                  <h3 className="text-lg font-bold">
                    Categories of Personal Information We Collect
                  </h3>
                </span>
              </strong>
              <span data-custom-class="body_text">
                The table below shows the categories of personal information we
                have collected in the past twelve (12) months. The table
                includes illustrative examples of each category and does not
                reflect the personal information we collect from you. For a
                comprehensive inventory of all personal information we process,
                please refer to the section{' '}
                <a
                  data-custom-class="link"
                  href="#infocollect"
                  className="text-blue-600 hover:underline"
                >
                  <span style={{ fontSize: '15px', color: 'rgb(89, 89, 89)' }}>
                    <span
                      style={{ fontSize: '15px', color: 'rgb(0, 58, 250)' }}
                    >
                      <span data-custom-class="body_text">
                        <span data-custom-class="link">
                          WHAT INFORMATION DO WE COLLECT?
                        </span>
                      </span>
                    </span>
                  </span>
                </a>
                {' }'}.
              </span>
            </span>
          </span>
        </div>

        <div style={{ lineHeight: '1.5' }}>
          <br />
        </div>

        <table style={{ width: '100%' }}>
          <thead>
            <tr>
              <th
                style={{
                  width: '33.8274%',
                  borderLeft: '1px solid black',
                  borderRight: '1px solid black',
                  borderTop: '1px solid black',
                  textAlign: 'left',
                }}
              >
                <span style={{ fontSize: '15px', color: 'rgb(89, 89, 89)' }}>
                  <span style={{ fontSize: '15px', color: 'rgb(89, 89, 89)' }}>
                    <span data-custom-class="body_text">
                      <strong>Category</strong>
                    </span>
                  </span>
                </span>
              </th>
              <th
                style={{
                  width: '51.4385%',
                  borderTop: '1px solid black',
                  borderRight: '1px solid black',
                  textAlign: 'left',
                }}
              >
                <span style={{ fontSize: '15px', color: 'rgb(89, 89, 89)' }}>
                  <span style={{ fontSize: '15px', color: 'rgb(89, 89, 89)' }}>
                    <span data-custom-class="body_text">
                      <strong>Examples</strong>
                    </span>
                  </span>
                </span>
              </th>
              <th
                style={{
                  width: '14.9084%',
                  borderRight: '1px solid black',
                  borderTop: '1px solid black',
                  textAlign: 'left',
                }}
              >
                <span style={{ fontSize: '15px', color: 'rgb(89, 89, 89)' }}>
                  <span style={{ fontSize: '15px', color: 'rgb(89, 89, 89)' }}>
                    <span data-custom-class="body_text">
                      <strong>Collected</strong>
                    </span>
                  </span>
                </span>
              </th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td
                style={{
                  width: '33.8274%',
                  borderLeft: '1px solid black',
                  borderRight: '1px solid black',
                  borderTop: '1px solid black',
                }}
              >
                <div style={{ lineHeight: '1.5' }}>
                  <span style={{ fontSize: '15px', color: 'rgb(89, 89, 89)' }}>
                    <span
                      style={{ fontSize: '15px', color: 'rgb(89, 89, 89)' }}
                    >
                      <span data-custom-class="body_text">A. Identifiers</span>
                    </span>
                  </span>
                </div>
              </td>
              <td
                style={{
                  width: '51.4385%',
                  borderTop: '1px solid black',
                  borderRight: '1px solid black',
                }}
              >
                <div style={{ lineHeight: '1.5' }}>
                  <span style={{ fontSize: '15px', color: 'rgb(89, 89, 89)' }}>
                    <span
                      style={{ fontSize: '15px', color: 'rgb(89, 89, 89)' }}
                    >
                      <span data-custom-class="body_text">
                        Contact details, such as real name, alias, postal
                        address, telephone or mobile contact number, unique
                        personal identifier, online identifier, Internet
                        Protocol address, email address, and account name
                      </span>
                    </span>
                  </span>
                </div>
              </td>
              <td
                style={{
                  width: '14.9084%',
                  textAlign: 'center',
                  verticalAlign: 'middle',
                  borderRight: '1px solid black',
                  borderTop: '1px solid black',
                }}
              >
                <div style={{ lineHeight: '1.5' }}>
                  <br />
                </div>
                <div style={{ lineHeight: '1.5' }}>
                  <span style={{ fontSize: '15px', color: 'rgb(89, 89, 89)' }}>
                    <span
                      style={{ fontSize: '15px', color: 'rgb(89, 89, 89)' }}
                    >
                      <span data-custom-class="body_text">YES</span>
                    </span>
                  </span>
                </div>
                <div style={{ lineHeight: '1.5' }}>
                  <br />
                </div>
              </td>
            </tr>
          </tbody>
        </table>

        <table style={{ width: '100%' }}>
          <tbody>
            <tr>
              <td
                style={{
                  width: '33.8274%',
                  borderLeft: '1px solid black',
                  borderRight: '1px solid black',
                  borderTop: '1px solid black',
                }}
              >
                <div style={{ lineHeight: '1.5' }}>
                  <span style={{ fontSize: '15px', color: 'rgb(89, 89, 89)' }}>
                    <span
                      style={{ fontSize: '15px', color: 'rgb(89, 89, 89)' }}
                    >
                      <span data-custom-class="body_text">
                        B. Personal information as defined in the California
                        Customer Records statute
                      </span>
                    </span>
                  </span>
                </div>
              </td>
              <td
                style={{
                  width: '51.4385%',
                  borderRight: '1px solid black',
                  borderTop: '1px solid black',
                }}
              >
                <div style={{ lineHeight: '1.5' }}>
                  <span style={{ fontSize: '15px', color: 'rgb(89, 89, 89)' }}>
                    <span
                      style={{ fontSize: '15px', color: 'rgb(89, 89, 89)' }}
                    >
                      <span data-custom-class="body_text">
                        Name, contact information, education, employment,
                        employment history, and financial information
                      </span>
                    </span>
                  </span>
                </div>
              </td>
              <td
                style={{
                  width: '14.9084%',
                  textAlign: 'center',
                  borderRight: '1px solid black',
                  borderTop: '1px solid black',
                }}
              >
                <div style={{ lineHeight: '1.5' }}>
                  <br />
                </div>
                <div style={{ lineHeight: '1.5' }}>
                  <span style={{ fontSize: '15px', color: 'rgb(89, 89, 89)' }}>
                    <span
                      style={{ fontSize: '15px', color: 'rgb(89, 89, 89)' }}
                    >
                      <span data-custom-class="body_text">YES</span>
                    </span>
                  </span>
                </div>
                <div style={{ lineHeight: '1.5' }}>
                  <br />
                </div>
              </td>
            </tr>
          </tbody>
        </table>

        <table style={{ width: '100%' }}>
          <tbody>
            <tr>
              <td
                style={{
                  width: '33.8274%',
                  borderLeft: '1px solid black',
                  borderRight: '1px solid black',
                  borderTop: '1px solid black',
                }}
              >
                <div style={{ lineHeight: '1.5' }}>
                  <span style={{ fontSize: '15px', color: 'rgb(89, 89, 89)' }}>
                    <span
                      style={{ fontSize: '15px', color: 'rgb(89, 89, 89)' }}
                    >
                      <span data-custom-class="body_text">
                        C. Protected classification characteristics under state
                        or federal law
                      </span>
                    </span>
                  </span>
                </div>
              </td>
              <td
                style={{
                  width: '51.4385%',
                  borderRight: '1px solid black',
                  borderTop: '1px solid black',
                }}
              >
                <div style={{ lineHeight: '1.5' }}>
                  <span style={{ fontSize: '15px', color: 'rgb(89, 89, 89)' }}>
                    <span
                      style={{ fontSize: '15px', color: 'rgb(89, 89, 89)' }}
                    >
                      <span data-custom-class="body_text">
                        Gender, age, date of birth, race and ethnicity, national
                        origin, marital status, and other demographic data
                      </span>
                    </span>
                  </span>
                </div>
              </td>
              <td
                style={{
                  width: '14.9084%',
                  textAlign: 'center',
                  borderRight: '1px solid black',
                  borderTop: '1px solid black',
                }}
              >
                <div style={{ lineHeight: '1.5' }}>
                  <br />
                </div>
                <div
                  data-custom-class="body_text"
                  style={{ lineHeight: '1.5' }}
                >
                  <span data-custom-class="body_text">YES</span>
                </div>
                <div style={{ lineHeight: '1.5' }}>
                  <br />
                </div>
              </td>
            </tr>
            <tr>
              <td
                style={{
                  width: '33.8274%',
                  borderLeft: '1px solid black',
                  borderRight: '1px solid black',
                  borderTop: '1px solid black',
                }}
              >
                <div style={{ lineHeight: '1.5' }}>
                  <span style={{ fontSize: '15px', color: 'rgb(89, 89, 89)' }}>
                    <span
                      style={{ fontSize: '15px', color: 'rgb(89, 89, 89)' }}
                    >
                      <span data-custom-class="body_text">
                        D. Commercial information
                      </span>
                    </span>
                  </span>
                </div>
              </td>
              <td
                style={{
                  width: '51.4385%',
                  borderRight: '1px solid black',
                  borderTop: '1px solid black',
                }}
              >
                <div style={{ lineHeight: '1.5' }}>
                  <span style={{ fontSize: '15px', color: 'rgb(89, 89)' }}>
                    <span
                      style={{ fontSize: '15px', color: 'rgb(89, 89, 89)' }}
                    >
                      <span data-custom-class="body_text">
                        Transaction information, purchase history, financial
                        details, and payment information
                      </span>
                    </span>
                  </span>
                </div>
              </td>
              <td
                style={{
                  width: '14.9084%',
                  textAlign: 'center',
                  borderRight: '1px solid black',
                  borderTop: '1px solid black',
                }}
              >
                <div style={{ lineHeight: '1.5' }}>
                  <br />
                </div>
                <div
                  data-custom-class="body_text"
                  style={{ lineHeight: '1.5' }}
                >
                  <span data-custom-class="body_text">YES</span>
                </div>
                <div style={{ lineHeight: '1.5' }}>
                  <br />
                </div>
              </td>
            </tr>
            <tr>
              <td
                style={{
                  width: '33.8274%',
                  borderLeft: '1px solid black',
                  borderRight: '1px solid black',
                  borderTop: '1px solid black',
                }}
              >
                <div style={{ lineHeight: '1.5' }}>
                  <span style={{ fontSize: '15px', color: 'rgb(89, 89, 89)' }}>
                    <span
                      style={{ fontSize: '15px', color: 'rgb(89, 89, 89)' }}
                    >
                      <span data-custom-class="body_text">
                        E. Biometric information
                      </span>
                    </span>
                  </span>
                </div>
              </td>
              <td
                style={{
                  width: '51.4385%',
                  borderRight: '1px solid black',
                  borderTop: '1px solid black',
                }}
              >
                <div style={{ lineHeight: '1.5' }}>
                  <span style={{ fontSize: '15px', color: 'rgb(89, 89, 89)' }}>
                    <span
                      style={{ fontSize: '15px', color: 'rgb(89, 89, 89)' }}
                    >
                      <span data-custom-class="body_text">
                        Fingerprints and voiceprints
                      </span>
                    </span>
                  </span>
                </div>
              </td>
              <td
                style={{
                  width: '14.9084%',
                  textAlign: 'center',
                  borderRight: '1px solid black',
                  borderTop: '1px solid black',
                }}
              >
                <div style={{ lineHeight: '1.5' }}>
                  <br />
                </div>
                <div
                  data-custom-class="body_text"
                  style={{ lineHeight: '1.5' }}
                >
                  <span data-custom-class="body_text">NO</span>
                </div>
                <div style={{ lineHeight: '1.5' }}>
                  <br />
                </div>
              </td>
            </tr>
            <tr>
              <td
                style={{
                  width: '33.8274%',
                  borderLeft: '1px solid black',
                  borderRight: '1px solid black',
                  borderTop: '1px solid black',
                }}
              >
                <div style={{ lineHeight: '1.5' }}>
                  <span style={{ fontSize: '15px', color: 'rgb(89, 89, 89)' }}>
                    <span
                      style={{ fontSize: '15px', color: 'rgb(89, 89, 89)' }}
                    >
                      <span data-custom-class="body_text">
                        F. Internet or other similar network activity
                      </span>
                    </span>
                  </span>
                </div>
              </td>
              <td
                style={{
                  width: '51.4385%',
                  borderRight: '1px solid black',
                  borderTop: '1px solid black',
                }}
              >
                <div style={{ lineHeight: '1.5' }}>
                  <span style={{ fontSize: '15px', color: 'rgb(89, 89, 89)' }}>
                    <span
                      style={{ fontSize: '15px', color: 'rgb(89, 89, 89)' }}
                    >
                      <span data-custom-class="body_text">
                        Browsing history, search history, online behavior,
                        interest data, and interactions with our and other
                        websites, applications, systems, and advertisements
                      </span>
                    </span>
                  </span>
                </div>
              </td>
              <td
                style={{
                  width: '14.9084%',
                  textAlign: 'center',
                  borderRight: '1px solid black',
                  borderTop: '1px solid black',
                }}
              >
                <div style={{ lineHeight: '1.5' }}>
                  <br />
                </div>
                <div
                  data-custom-class="body_text"
                  style={{ lineHeight: '1.5' }}
                >
                  <span data-custom-class="body_text">NO</span>
                </div>
                <div style={{ lineHeight: '1.5' }}>
                  <br />
                </div>
              </td>
            </tr>
            <tr>
              <td
                style={{
                  width: '33.8274%',
                  borderLeft: '1px solid black',
                  borderRight: '1px solid black',
                  borderTop: '1px solid black',
                }}
              >
                <div style={{ lineHeight: '1.5' }}>
                  <span style={{ fontSize: '15px', color: 'rgb(89, 89, 89)' }}>
                    <span
                      style={{ fontSize: '15px', color: 'rgb(89, 89, 89)' }}
                    >
                      <span data-custom-class="body_text">
                        G. Geolocation data
                      </span>
                    </span>
                  </span>
                </div>
              </td>
              <td
                style={{
                  width: '51.4385%',
                  borderRight: '1px solid black',
                  borderTop: '1px solid black',
                }}
              >
                <div style={{ lineHeight: '1.5' }}>
                  <span style={{ fontSize: '15px', color: 'rgb(89, 89, 89)' }}>
                    <span
                      style={{ fontSize: '15px', color: 'rgb(89, 89, 89)' }}
                    >
                      <span data-custom-class="body_text">Device location</span>
                    </span>
                  </span>
                </div>
              </td>
              <td
                style={{
                  width: '14.9084%',
                  textAlign: 'center',
                  borderRight: '1px solid black',
                  borderTop: '1px solid black',
                }}
              >
                <div style={{ lineHeight: '1.5' }}>
                  <br />
                </div>
                <div
                  data-custom-class="body_text"
                  style={{ lineHeight: '1.5' }}
                >
                  <span data-custom-class="body_text">NO</span>
                </div>
                <div style={{ lineHeight: '1.5' }}>
                  <br />
                </div>
              </td>
            </tr>
            <tr>
              <td
                style={{
                  width: '33.8274%',
                  borderLeft: '1px solid black',
                  borderRight: '1px solid black',
                  borderTop: '1px solid black',
                }}
              >
                <div style={{ lineHeight: '1.5' }}>
                  <span style={{ fontSize: '15px', color: 'rgb(89, 89, 89)' }}>
                    <span
                      style={{ fontSize: '15px', color: 'rgb(89, 89, 89)' }}
                    >
                      <span data-custom-class="body_text">
                        H. Audio, electronic, sensory, or similar information
                      </span>
                    </span>
                  </span>
                </div>
              </td>
              <td
                style={{
                  width: '51.4385%',
                  borderRight: '1px solid black',
                  borderTop: '1px solid black',
                }}
              >
                <div style={{ lineHeight: '1.5' }}>
                  <span style={{ fontSize: '15px', color: 'rgb(89, 89, 89)' }}>
                    <span
                      style={{ fontSize: '15px', color: 'rgb(89, 89, 89)' }}
                    >
                      <span data-custom-class="body_text">
                        Images and audio, video or call recordings created in
                        connection with our business activities
                      </span>
                    </span>
                  </span>
                </div>
              </td>
              <td
                style={{
                  width: '14.9084%',
                  textAlign: 'center',
                  borderRight: '1px solid black',
                  borderTop: '1px solid black',
                }}
              >
                <div style={{ lineHeight: '1.5' }}>
                  <br />
                </div>
                <div
                  data-custom-class="body_text"
                  style={{ lineHeight: '1.5' }}
                >
                  <span data-custom-class="body_text">NO</span>
                </div>
                <div style={{ lineHeight: '1.5' }}>
                  <br />
                </div>
              </td>
            </tr>
            <tr>
              <td
                style={{
                  width: '33.8274%',
                  borderLeft: '1px solid black',
                  borderRight: '1px solid black',
                  borderTop: '1px solid black',
                }}
              >
                <div style={{ lineHeight: '1.5' }}>
                  <span style={{ fontSize: '15px', color: 'rgb(89, 89, 89)' }}>
                    <span
                      style={{ fontSize: '15px', color: 'rgb(89, 89, 89)' }}
                    >
                      <span data-custom-class="body_text">
                        I. Professional or employment-related information
                      </span>
                    </span>
                  </span>
                </div>
              </td>
              <td
                style={{
                  width: '51.4385%',
                  borderRight: '1px solid black',
                  borderTop: '1px solid black',
                }}
              >
                <div style={{ lineHeight: '1.5' }}>
                  <span style={{ fontSize: '15px', color: 'rgb(89, 89, 89)' }}>
                    <span
                      style={{ fontSize: '15px', color: 'rgb(89, 89, 89)' }}
                    >
                      <span data-custom-class="body_text">
                        Business contact details in order to provide you our
                        Services at a business level or job title, work history,
                        and professional qualifications if you apply for a job
                        with us
                      </span>
                    </span>
                  </span>
                </div>
              </td>
              <td
                style={{
                  width: '14.9084%',
                  textAlign: 'center',
                  borderRight: '1px solid black',
                  borderTop: '1px solid black',
                }}
              >
                <div style={{ lineHeight: '1.5' }}>
                  <br />
                </div>
                <div
                  data-custom-class="body_text"
                  style={{ lineHeight: '1.5' }}
                >
                  <span data-custom-class="body_text">YES</span>
                </div>
                <div style={{ lineHeight: '1.5' }}>
                  <br />
                </div>
              </td>
            </tr>
            <tr>
              <td
                style={{
                  borderLeft: '1px solid black',
                  borderRight: '1px solid black',
                  borderTop: '1px solid black',
                  width: '33.8274%',
                }}
              >
                <div style={{ lineHeight: '1.5' }}>
                  <span style={{ fontSize: '15px', color: 'rgb(89, 89)' }}>
                    <span
                      style={{ fontSize: '15px', color: 'rgb(89, 89, 89)' }}
                    >
                      <span data-custom-class="body_text">
                        J. Education Information
                      </span>
                    </span>
                  </span>
                </div>
              </td>
              <td
                style={{
                  borderRight: '1px solid black',
                  borderTop: '1px solid black',
                  width: '51.4385%',
                }}
              >
                <div style={{ lineHeight: '1.5' }}>
                  <span style={{ fontSize: '15px', color: 'rgb(89, 89, 89)' }}>
                    <span
                      style={{ fontSize: '15px', color: 'rgb(89, 89, 89)' }}
                    >
                      <span data-custom-class="body_text">
                        Student records and directory information
                      </span>
                    </span>
                  </span>
                </div>
              </td>
              <td
                style={{
                  textAlign: 'center',
                  borderRight: '1px solid black',
                  borderTop: '1px solid black',
                  width: '14.9084%',
                }}
              >
                <div style={{ lineHeight: '1.5' }}>
                  <br />
                </div>
                <div
                  data-custom-class="body_text"
                  style={{ lineHeight: '1.5' }}
                >
                  <span data-custom-class="body_text">YES</span>
                </div>
                <div style={{ lineHeight: '1.5' }}>
                  <br />
                </div>
              </td>
            </tr>
            <tr>
              <td
                style={{
                  borderWidth: '1px',
                  borderColor: 'black',
                  borderStyle: 'solid',
                  width: '33.8274%',
                }}
              >
                <div style={{ lineHeight: '1.5' }}>
                  <span style={{ fontSize: '15px', color: 'rgb(89, 89, 89)' }}>
                    <span
                      style={{ fontSize: '15px', color: 'rgb(89, 89, 89)' }}
                    >
                      <span data-custom-class="body_text">
                        K. Inferences drawn from collected personal information
                      </span>
                    </span>
                  </span>
                </div>
              </td>
              <td
                style={{
                  borderBottom: '1px solid black',
                  borderTop: '1px solid black',
                  borderRight: '1px solid black',
                  width: '51.4385%',
                }}
              >
                <div style={{ lineHeight: '1.5' }}>
                  <span style={{ fontSize: '15px', color: 'rgb(89, 89, 89)' }}>
                    <span
                      style={{ fontSize: '15px', color: 'rgb(89, 89, 89)' }}
                    >
                      <span data-custom-class="body_text">
                        Inferences drawn from any of the collected personal
                        information listed above to create a profile or summary
                        about, for example, an individual&apos;s preferences and
                        characteristics
                      </span>
                    </span>
                  </span>
                </div>
              </td>
              <td
                style={{
                  textAlign: 'center',
                  borderRight: '1px solid black',
                  borderBottom: '1px solid black',
                  borderTop: '1px solid black',
                  width: '14.9084%',
                }}
              >
                <div style={{ lineHeight: '1.5' }}>
                  <br />
                </div>
                <div
                  data-custom-class="body_text"
                  style={{ lineHeight: '1.5' }}
                >
                  <span data-custom-class="body_text">NO</span>
                </div>
                <div style={{ lineHeight: '1.5' }}>
                  <br />
                </div>
              </td>
            </tr>
            <tr>
              <td
                style={{
                  borderLeft: '1px solid black',
                  borderRight: '1px solid black',
                  borderBottom: '1px solid black',
                  lineHeight: '1.5',
                }}
              >
                <span data-custom-class="body_text">
                  L. Sensitive personal Information
                </span>
              </td>
              <td
                style={{
                  borderRight: '1px solid black',
                  borderBottom: '1px solid black',
                  lineHeight: '1.5',
                }}
              >
                <span data-custom-class="body_text">
                  Account login information, drivers&apos; licenses, financial
                  information including account access details, state id card
                  numbers, social security numbers and status as transgender or
                  nonbinary
                </span>
              </td>
              <td
                style={{
                  borderRight: '1px solid black',
                  borderBottom: '1px solid black',
                }}
              >
                <div data-empty="true" style={{ textAlign: 'center' }}>
                  <br />
                </div>
                <div
                  data-custom-class="body_text"
                  data-empty="true"
                  style={{ textAlign: 'center', lineHeight: '1.5' }}
                >
                  <span data-custom-class="body_text">YES</span>
                </div>
                <div data-empty="true" style={{ textAlign: 'center' }}>
                  <br />
                </div>
              </td>
            </tr>
          </tbody>
        </table>

        <div style={{ lineHeight: '1.5' }}>
          <br />
        </div>

        <div style={{ lineHeight: '1.5' }}>
          <span style={{ fontSize: '15px' }}>
            <span data-custom-class="body_text">
              We only collect sensitive personal information, as defined by
              applicable privacy laws or the purposes allowed by law or with
              your consent. Sensitive personal information may be used, or
              disclosed to a service provider or contractor, for additional,
              specified purposes. You may have the right to limit the use or
              disclosure of your sensitive personal information. We do not
              collect or process sensitive personal information for the purpose
              of inferring characteristics about you.
            </span>
          </span>
        </div>

        <div style={{ lineHeight: '1.5' }}>
          <br />
        </div>

        <div style={{ lineHeight: '1.5' }}>
          <span style={{ fontSize: '15px' }}>
            <span data-custom-class="body_text">
              We may also collect other personal information outside of these
              categories through instances where you interact with us in person,
              online, or by phone or mail in the context of:
            </span>
          </span>
        </div>

        <ul>
          <li data-custom-class="body_text" style={{ lineHeight: '1.5' }}>
            <span style={{ fontSize: '15px' }}>
              Receiving help through our customer support channels;
            </span>
          </li>
        </ul>

        <ul>
          <li data-custom-class="body_text">
            <span style={{ fontSize: '15px' }}>
              Participation in customer surveys or contests; and
            </span>
          </li>
        </ul>

        <ul>
          <li data-custom-class="body_text">
            <span style={{ fontSize: '15px' }}>
              Facilitation in the delivery of our Services and to respond to
              your inquiries.
            </span>
          </li>
        </ul>

        <div style={{ lineHeight: '1.5' }}>
          <span data-custom-class="body_text">
            <span style={{ fontSize: '15px' }}>
              We will use and retain the collected personal information as
              needed to provide the Services or for:
            </span>
          </span>
        </div>

        <ul>
          <li data-custom-class="body_text" style={{ lineHeight: '1.5' }}>
            <span data-custom-class="body_text">
              Category A - As long as the user has an account with us
            </span>
          </li>
        </ul>

        <ul>
          <li data-custom-class="body_text" style={{ lineHeight: '1.5' }}>
            <span data-custom-class="body_text">
              Category B - As long as the user has an account with us
            </span>
          </li>
        </ul>

        <ul>
          <li data-custom-class="body_text" style={{ lineHeight: '1.5' }}>
            <span data-custom-class="body_text">
              Category C - As long as the user has an account with us
            </span>
          </li>
        </ul>

        <ul>
          <li data-custom-class="body_text" style={{ lineHeight: '1.5' }}>
            <span data-custom-class="body_text">
              Category D - As long as the user has an account with us
            </span>
          </li>
        </ul>

        <ul>
          <li data-custom-class="body_text" style={{ lineHeight: '1.5' }}>
            <span data-custom-class="body_text">
              Category I - As long as the user has an account with us
            </span>
          </li>
        </ul>

        <ul>
          <li data-custom-class="body_text" style={{ lineHeight: '1.5' }}>
            <span data-custom-class="body_text">
              Category J - As long as the user has an account with us
            </span>
          </li>
        </ul>

        <ul>
          <li data-custom-class="body_text" style={{ lineHeight: '1.5' }}>
            <span data-custom-class="body_text">
              Category L - As long as the user has an account with us
            </span>
          </li>
        </ul>

        <div style={{ lineHeight: '1.5' }}>
          <strong>
            <span style={{ fontSize: '15px' }}>
              <span data-custom-class="heading_2">
                <h3 className="text-lg font-bold">
                  Sources of Personal Information
                </h3>
              </span>
            </span>
          </strong>
          <span style={{ fontSize: '15px' }}>
            <span data-custom-class="body_text">
              Learn more about the sources of personal information we collect in{' '}
              <a
                data-custom-class="link"
                href="#infocollect"
                className="text-blue-600 hover:underline"
              >
                WHAT INFORMATION DO WE COLLECT?
              </a>
              .
            </span>
          </span>
          <span style={{ fontSize: '15px', color: 'rgb(89, 89, 89)' }}>
            <span style={{ fontSize: '15px', color: 'rgb(89, 89)' }}>
              <strong>
                <span data-custom-class="heading_2">
                  <h3 className="text-lg font-bold">
                    How We Use and Share Personal Information
                  </h3>
                </span>
              </strong>
            </span>
          </span>
          <span data-custom-class="body_text" style={{ fontSize: '15px' }}>
            Learn more about how we use your personal information in the
            section,{' '}
            <a
              data-custom-class="link"
              href="#infouse"
              className="text-blue-600 hover:underline"
            >
              HOW DO WE PROCESS YOUR INFORMATION?
            </a>
            .
          </span>
        </div>

        <div style={{ lineHeight: '1.5' }}>
          <br />
        </div>

        <div style={{ lineHeight: '1.5' }}>
          <span style={{ fontSize: '15px', color: 'rgb(89, 89)' }}>
            <span style={{ fontSize: '15px', color: 'rgb(89, 89, 89)' }}>
              <span data-custom-class="body_text">
                <strong>
                  Will your information be shared with anyone else?
                </strong>
              </span>
            </span>
          </span>
        </div>

        <div style={{ lineHeight: '1.5' }}>
          <br />
        </div>

        <div style={{ lineHeight: '1.5' }}>
          <span style={{ fontSize: '15px', color: 'rgb(89, 89, 89)' }}>
            <span style={{ fontSize: '15px', color: 'rgb(89, 89, 89)' }}>
              <span data-custom-class="body_text">
                We may disclose your personal information with our service
                providers pursuant to a written contract between us and each
                service provider. Learn more about how we disclose personal
                information to in the section,{' '}
                <a
                  data-custom-class="link"
                  href="#whoshare"
                  className="text-blue-600 hover:underline"
                >
                  WHEN AND WITH WHOM DO WE SHARE YOUR PERSONAL INFORMATION?
                </a>
                .
              </span>
            </span>
          </span>
        </div>

        <div style={{ lineHeight: '1.5' }}>
          <br />
        </div>

        <div style={{ lineHeight: '1.5' }}>
          <span style={{ fontSize: '15px', color: 'rgb(89, 89, 89)' }}>
            <span style={{ fontSize: '15px', color: 'rgb(89, 89, 89)' }}>
              <span data-custom-class="body_text">
                We may use your personal information for our own business
                purposes, such as for undertaking internal research for
                technological development and demonstration. This is not
                considered to be &quot;selling&quot; of your personal
                information.
              </span>
            </span>
          </span>
        </div>

        <div style={{ lineHeight: '1.5' }}>
          <br />
        </div>

        <div style={{ lineHeight: '1.5' }}>
          <span style={{ fontSize: '15px', color: 'rgb(89, 89)' }}>
            <span style={{ fontSize: '15px', color: 'rgb(89, 89, 89)' }}>
              <span data-custom-class="body_text">
                We have not disclosed, sold, or shared any personal information
                to third parties for a business or commercial purpose in the
                preceding twelve (12) months. We will not sell or share personal
                information in the future belonging to website visitors, users,
                and other consumers.
              </span>
            </span>
          </span>
        </div>

        <div style={{ lineHeight: '1.5' }}>
          <br />
        </div>

        <div style={{ lineHeight: '1.5' }}>
          <span style={{ fontSize: '15px' }}>
            <strong>
              <span data-custom-class="heading_2">
                <h3 className="text-lg font-bold">Your Rights</h3>
              </span>
            </strong>
            <span data-custom-class="body_text">
              You have rights under certain US state data protection laws.
              However, these rights are not absolute, and in certain cases, we
              may decline your request as permitted by law. These rights
              include:
            </span>
          </span>
        </div>

        <ul>
          <li data-custom-class="body_text" style={{ lineHeight: '1.5' }}>
            <span style={{ fontSize: '15px' }}>
              <strong>Right to know</strong> whether or not we are processing
              your personal data
            </span>
          </li>
        </ul>

        <ul>
          <li data-custom-class="body_text" style={{ lineHeight: '1.5' }}>
            <span style={{ fontSize: '15px' }}>
              <strong>Right to access </strong>your personal data
            </span>
          </li>
        </ul>

        <ul>
          <li data-custom-class="body_text" style={{ lineHeight: '1.5' }}>
            <span style={{ fontSize: '15px' }}>
              <strong>Right to correct </strong>inaccuracies in your personal
              data
            </span>
          </li>
        </ul>

        <ul>
          <li data-custom-class="body_text" style={{ lineHeight: '1.5' }}>
            <span style={{ fontSize: '15px' }}>
              <strong>Right to request</strong> the deletion of your personal
              data
            </span>
          </li>
        </ul>

        <ul>
          <li data-custom-class="body_text" style={{ lineHeight: '1.5' }}>
            <span style={{ fontSize: '15px' }}>
              <strong>Right to obtain a copy </strong>of the personal data you
              previously shared with us
            </span>
          </li>
        </ul>

        <ul>
          <li data-custom-class="body_text" style={{ lineHeight: '1.5' }}>
            <span style={{ fontSize: '15px' }}>
              <strong>Right to non-discrimination</strong> for exercising your
              rights
            </span>
          </li>
        </ul>

        <ul>
          <li data-custom-class="body_text" style={{ lineHeight: '1.5' }}>
            <span style={{ fontSize: '15px' }}>
              <strong>Right to opt out</strong> of the processing of your
              personal data if it is used for targeted advertising (or sharing
              as defined under California&apos;s privacy law), the sale of
              personal data, or profiling in furtherance of decisions that
              produce legal or similarly significant effects
              (&quot;profiling&quot;)
            </span>
          </li>
        </ul>

        <div style={{ lineHeight: '1.5' }}>
          <br />
        </div>

        <div style={{ lineHeight: '1.5' }}>
          <span style={{ fontSize: '15px' }}>
            <span data-custom-class="body_text">
              Depending upon the state where you live, you may also have the
              following rights:
            </span>
          </span>
        </div>

        <ul>
          <li data-custom-class="body_text" style={{ lineHeight: '1.5' }}>
            <span style={{ fontSize: '15px' }}>
              Right to access the categories of personal data being processed
              (as permitted by applicable law, including the privacy law in
              Minnesota)
            </span>
          </li>
        </ul>

        <ul>
          <li data-custom-class="body_text" style={{ lineHeight: '1.5' }}>
            <span style={{ fontSize: '15px' }}>
              Right to obtain a list of the categories of third parties to which
              we have disclosed personal data (as permitted by applicable law,
              including the privacy law in California, Delaware, and Maryland)
            </span>
          </li>
        </ul>

        <ul>
          <li data-custom-class="body_text" style={{ lineHeight: '1.5' }}>
            <span style={{ fontSize: '15px' }}>
              Right to obtain a list of specific third parties to which we have
              disclosed personal data (as permitted by applicable law, including
              the privacy law in Minnesota and Oregon)
            </span>
          </li>
        </ul>

        <ul>
          <li
            data-custom-class="body_text"
            style={{ lineHeight: '1.5', fontSize: '15px' }}
          >
            <span style={{ fontSize: '15px' }}>
              Right to obtain a list of third parties to which we have sold
              personal data (as permitted by applicable law, including the
              privacy law in Connecticut)
            </span>
          </li>
        </ul>

        <ul>
          <li data-custom-class="body_text" style={{ lineHeight: '1.5' }}>
            <span style={{ fontSize: '15px' }}>
              Right to review, understand, question, and depending on where you
              live, correct how personal data has been profiled (as permitted by
              applicable law, including the privacy law in Connecticut and
              Minnesota)
            </span>
          </li>
        </ul>

        <ul>
          <li data-custom-class="body_text" style={{ lineHeight: '1.5' }}>
            <span style={{ fontSize: '15px' }}>
              Right to limit use and disclosure of sensitive personal data (as
              permitted by applicable law, including the privacy law in
              California)
            </span>
          </li>
        </ul>

        <ul>
          <li data-custom-class="body_text" style={{ lineHeight: '1.5' }}>
            <span style={{ fontSize: '15px' }}>
              Right to opt out of the collection of sensitive data and personal
              data collected through the operation of a voice or facial
              recognition feature (as permitted by applicable law, including the
              privacy law in Florida)
            </span>
          </li>
        </ul>

        <div style={{ lineHeight: '1.5' }}>
          <span style={{ fontSize: '15px' }}>
            <span data-custom-class="body_text">
              <strong>How to Exercise Your Rights</strong>
            </span>
          </span>
          <span style={{ fontSize: '15px', color: 'rgb(89, 89)' }}>
            <span style={{ fontSize: '15px', color: 'rgb(89, 89)' }}>
              <span data-custom-class="body_text">
                To exercise these rights, you can contact us by visiting{' '}
                <a
                  target="_blank"
                  data-custom-class="link"
                  href="https://Multitaxx.com"
                  className="text-blue-600 hover:underline"
                  rel="noreferrer"
                >
                  https://Multitaxx.com
                </a>
                , by emailing us at{' '}
                <a
                  target="_blank"
                  data-custom-class="link"
                  href="mailto:info@multitaxx.com"
                  className="text-blue-600 hover:underline"
                  rel="noreferrer"
                >
                  info@multitaxx.com
                </a>
                , by calling toll-free at 702-337-6272, by visiting{' '}
                <a
                  target="_blank"
                  data-custom-class="link"
                  href="https://Multitaxx.com"
                  className="text-blue-600 hover:underline"
                  rel="noreferrer"
                >
                  https://Multitaxx.com
                </a>
                , or by referring to the contact details at the bottom of this
                document.
              </span>
            </span>
          </span>
        </div>

        <div style={{ lineHeight: '1.5' }}>
          <br />
        </div>

        <div style={{ lineHeight: '1.5' }}>
          <span style={{ fontSize: '15px' }}>
            <span data-custom-class="body_text">
              Under certain US state data protection laws, you can designate an
              authorized agent to make a request on your behalf. We may deny a
              request from an authorized agent that does not submit proof that
              they have been validly authorized to act on your behalf in
              accordance with applicable laws.
            </span>
            <br />
            <strong>
              <span data-custom-class="heading_2">
                <h3 className="text-lg font-bold">Request Verification</h3>
              </span>
            </strong>
            <span data-custom-class="body_text">
              Upon receiving your request, we will need to verify your identity
              to determine you are the same person about whom we have the
              information in our system. We will only use personal information
              provided in your request to verify your identity or authority to
              make the request. However, if we cannot verify your identity from
              the information already maintained by us, we may request that you
              provide additional information for the purposes of verifying your
              identity and for security or fraud-prevention purposes.
            </span>
          </span>
        </div>

        <div style={{ lineHeight: '1.5' }}>
          <span style={{ fontSize: '15px' }}>
            <br />
          </span>
        </div>

        <div style={{ lineHeight: '1.5' }}>
          <span style={{ fontSize: '15px' }}>
            <span data-custom-class="body_text">
              If you submit the request through an authorized agent, we may need
              to collect additional information to verify your identity before
              processing your request and the agent will need to provide a
              written and signed permission from you to submit such request on
              your behalf.
            </span>
            <span style={{ fontSize: '15px' }}>
              <span data-custom-class="heading_2">
                <strong>
                  <h3 className="text-lg font-bold">Appeals</h3>
                </strong>
              </span>
              <span data-custom-class="body_text">
                Under certain US state data protection laws, if we decline to
                take action regarding your request, you may appeal our decision
                by emailing us at{' '}
                <a
                  target="_blank"
                  data-custom-class="link"
                  href="mailto:info@multitaxx.com"
                  className="text-blue-600 hover:underline"
                  rel="noreferrer"
                >
                  info@multitaxx.com
                </a>
                . We will inform you in writing of any action taken or not taken
                in response to the appeal, including a written explanation of
                the reasons for the decisions. If your appeal is denied, you may
                submit a complaint to your state attorney general.
              </span>
            </span>
          </span>
        </div>

        <div style={{ lineHeight: '1.5' }}>
          <br />
        </div>

        <div style={{ lineHeight: '1.5' }}>
          <span style={{ fontSize: '15px' }}>
            <strong>
              <span data-custom-class="heading_2">
                <h3 className="text-lg font-bold">
                  California &quot;Shine The Light&quot; Law
                </h3>
              </span>
            </strong>
            <span data-custom-class="body_text">
              California Civil Code Section 1798.83, also known as the
              &quot;Shine The Light&quot; law, permits our users who are
              California residents to request and obtain from us, once a year
              and free of charge, information about categories of personal
              information (if any) we disclosed to third parties for direct
              marketing purposes and the names and addresses of all third
              parties with which we shared personal information in the
              immediately preceding calendar year. If you are a California
              resident and would like to make such a request, please submit your
              request in writing to us by using the contact details provided in
              the section{' '}
              <a
                data-custom-class="link"
                href="#contact"
                className="text-blue-600 hover:underline"
              >
                HOW CAN YOU CONTACT US ABOUT THIS NOTICE?
              </a>
              .
            </span>
          </span>
        </div>

        <div style={{ lineHeight: '1.5' }}>
          <br />
        </div>

        <div id="policyupdates" style={{ lineHeight: '1.5' }}>
          <span style={{ color: 'rgb(127, 127, 127)' }}>
            <span style={{ color: 'rgb(89, 89, 89)', fontSize: '15px' }}>
              <span style={{ fontSize: '15px', color: 'rgb(89, 89, 89)' }}>
                <span style={{ fontSize: '15px', color: 'rgb(89, 89)' }}>
                  <span id="control" style={{ color: 'rgb(0, 0, 0)' }}>
                    <strong>
                      <span data-custom-class="heading_1">
                        <h2 className="text-2xl font-bold">
                          11. DO WE MAKE UPDATES TO THIS NOTICE?
                        </h2>
                      </span>
                    </strong>
                  </span>
                </span>
              </span>
            </span>
          </span>
          <span style={{ fontSize: '15px', color: 'rgb(89, 89)' }}>
            <span style={{ fontSize: '15px', color: 'rgb(89, 89, 89)' }}>
              <span data-custom-class="body_text">
                <em>
                  <strong>In Short: </strong>
                  Yes, we will update this notice as necessary to stay compliant
                  with relevant laws.
                </em>
              </span>
            </span>
          </span>
        </div>

        <div style={{ lineHeight: '1.5' }}>
          <br />
        </div>

        <div style={{ lineHeight: '1.5' }}>
          <span style={{ fontSize: '15px', color: 'rgb(89, 89)' }}>
            <span style={{ fontSize: '15px', color: 'rgb(89, 89, 89)' }}>
              <span data-custom-class="body_text">
                We may update this Privacy Notice from time to time. The updated
                version will be indicated by an updated &quot;Revised&quot; date
                at the top of this Privacy Notice. If we make material changes
                to this Privacy Notice, we may notify you either by prominently
                posting a notice of such changes or by directly sending you a
                notification. We encourage you to review this Privacy Notice
                frequently to be informed of how we are protecting your
                information.
              </span>
            </span>
          </span>
        </div>

        <div style={{ lineHeight: '1.5' }}>
          <br />
        </div>

        <div id="contact" style={{ lineHeight: '1.5' }}>
          <span style={{ color: 'rgb(127, 127, 127)' }}>
            <span style={{ color: 'rgb(89, 89)', fontSize: '15px' }}>
              <span style={{ fontSize: '15px', color: 'rgb(89, 89, 89)' }}>
                <span style={{ fontSize: '15px', color: 'rgb(89, 89, 89)' }}>
                  <span id="control" style={{ color: 'rgb(0, 0, 0)' }}>
                    <strong>
                      <span data-custom-class="heading_1">
                        <h2 className="text-2xl font-bold">
                          12. HOW CAN YOU CONTACT US ABOUT THIS NOTICE?
                        </h2>
                      </span>
                    </strong>
                  </span>
                </span>
              </span>
            </span>
          </span>
          <span style={{ fontSize: '15px', color: 'rgb(89, 89, 89)' }}>
            <span style={{ fontSize: '15px', color: 'rgb(89, 89, 89)' }}>
              <span data-custom-class="body_text">
                If you have questions or comments about this notice, you may
                email us at{' '}
                <a
                  target="_blank"
                  data-custom-class="link"
                  href="mailto:info@multitaxx.com"
                  className="text-blue-600 hover:underline"
                  rel="noreferrer"
                >
                  info@multitaxx.com
                </a>{' '}
                or contact us by post at:
              </span>
            </span>
          </span>
        </div>

        <div style={{ lineHeight: '1.5' }}>
          <br />
        </div>

        <div style={{ lineHeight: '1.5' }}>
          <span style={{ fontSize: '15px', color: 'rgb(89, 89)' }}>
            <span style={{ fontSize: '15px', color: 'rgb(89, 89)' }}>
              <span data-custom-class="body_text">
                <span style={{ fontSize: '15px' }}>
                  <span style={{ color: 'rgb(89, 89, 89)' }}>
                    <span style={{ color: 'rgb(89, 89, 89)' }}>
                      <span data-custom-class="body_text">MultiTax</span>
                    </span>
                  </span>
                </span>
              </span>
            </span>
          </span>
        </div>

        <div style={{ lineHeight: '1.5' }}>
          <span style={{ fontSize: '15px' }}>
            <span data-custom-class="body_text">
              1725 S Rainbow Blvd suite 19, Las Vegas, NV 89146, USA
            </span>
          </span>
        </div>

        <div style={{ lineHeight: '1.5' }}>
          <span style={{ fontSize: '15px' }}>
            <span data-custom-class="body_text">Las Vegas, NV 89146</span>
          </span>
        </div>

        <div style={{ lineHeight: '1.5' }}>
          <span data-custom-class="body_text" style={{ fontSize: '15px' }}>
            United States
          </span>
        </div>

        <div style={{ lineHeight: '1.5' }}>
          <br />
        </div>

        <div id="request" style={{ lineHeight: '1.5' }}>
          <span style={{ color: 'rgb(127, 127, 127)' }}>
            <span style={{ color: 'rgb(89, 89)', fontSize: '15px' }}>
              <span style={{ fontSize: '15px', color: 'rgb(89, 89, 89)' }}>
                <span style={{ fontSize: '15px', color: 'rgb(89, 89, 89)' }}>
                  <span id="control" style={{ color: 'rgb(0, 0, 0)' }}>
                    <strong>
                      <span data-custom-class="heading_1">
                        <h2 className="text-2xl font-bold">
                          13. HOW CAN YOU REVIEW, UPDATE, OR DELETE THE DATA WE
                          COLLECT FROM YOU?
                        </h2>
                      </span>
                    </strong>
                  </span>
                </span>
              </span>
            </span>
          </span>
          <span style={{ fontSize: '15px', color: 'rgb(89, 89, 89)' }}>
            <span style={{ fontSize: '15px', color: 'rgb(89, 89, 89)' }}>
              <span data-custom-class="body_text">
                Based on the applicable laws of your country or state of
                residence in the US, you may have the right to request access to
                the personal information we collect from you, details about how
                we have processed it, correct inaccuracies, or delete your
                personal information. You may also have the right to withdraw
                your consent to our processing of your personal information.
                These rights may be limited in some circumstances by applicable
                law. To request to review, update, or delete your personal
                information, please visit:{' '}
                <a
                  target="_blank"
                  data-custom-class="link"
                  href="https://Multitaxx.com"
                  className="text-blue-600 hover:underline"
                  rel="noreferrer"
                >
                  https://Multitaxx.com
                </a>
                .
              </span>
            </span>
          </span>
        </div>
      </div>
    </div>
  );
};

export default PrivacyPolicy;
